<template>
  <v-app class="custom_bg">
    <v-container>
      <v-row>
        <v-col cols="12" md="12">
          <div>
            <v-btn color="primary mb-4" @click="back()" class="d-print-none"
              >Back</v-btn
            >
          </div>
          <v-card class="">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="12">
                  <div
                    v-if="product.type === 'goods' || product.type === 'Goods' || product.type === 'products'"
                    class="d-flex align-center justify-start"
                  >
                    <v-dialog v-model="dialog1" persistent max-width="600px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          class="text-capitalize mx-2"
                          width="95"
                          v-bind="attrs"
                          v-on="on"
                          >Add stock</v-btn
                        >
                      </template>
                      <v-card>
                        <v-card-text>
                          <v-card-title>Add Stock</v-card-title>
                          <span class="pl-3"
                            >Please enter number of product to add</span
                          >
                          <v-col cols="12" md="12">
                            <v-text-field
                              label="Stock Count"
                              outlined
                              type="number"
                              v-model="aStock"
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="dialog1 = false" text
                              >cancel</v-btn
                            >
                            <v-btn
                              color="primary"
                             
                              @click="add(product.pid)"
                              @keyup.enter="add(product.pid)"
                              :loading="loading1"
                              >save</v-btn
                            >
                          </v-card-actions>
                        </v-card-text>
                      </v-card>
                    </v-dialog>

                    <v-dialog v-model="dialog2" persistent max-width="600px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          class="text-capitalize mr-2"
                          width="95"
                          v-bind="attrs"
                          v-on="on"
                          >Remove stock</v-btn
                        >
                      </template>

                      <v-card>
                        <v-card-text>
                          <v-card-title>Remove Stock</v-card-title>
                          <span class="pl-3"
                            >Please enter number of product to remove</span
                          >
                          <v-col cols="12" md="12">
                            <v-text-field
                              label="Stock Count"
                              outlined
                              v-model="rStock"
                              dense
                              type="number"
                            ></v-text-field>
                          </v-col>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="dialog2 = false"
                              >cancel</v-btn
                            >
                            <v-btn
                              color="primary"
                              text
                              type="submit"
                              :loading="loading2"
                              @click="remove(product.pid)"
                              >save</v-btn
                            >
                          </v-card-actions>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </div>
                  <v-card-title v-else>
                    Sorry you cannot add/remove stock of product of type service
                  </v-card-title>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="d-flex align-center justidy-center">
                    <v-card flat>
                      <v-card-text>
                        <p class="text-h6 elevation-2 pa-4 ">
                          <strong>Product Name</strong> {{ product.name }}
                        </p>
                        <p class="text-h6 elevation-2 pa-4">
                          <strong>Description</strong> {{ product.description }}
                        </p>
                        <p class="text-h6 elevation-2 pa-4">
                          <strong>Price</strong> {{ product.price }}
                        </p>
                        <p class="text-h6 elevation-2 pa-4">
                          <strong>Product Type</strong> {{ product.type }}
                        </p>

                        <p class="text-h6 elevation-2 pa-4">
                          <strong>Price</strong> {{ product.price }}
                        </p>
                        <p class="text-h6 elevation-2 pa-4">
                          <strong>Current stock</strong> {{ product.stock }}
                        </p>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-col>
                <v-col cols="12" md="8">
                  <v-card
                    outlined
                    style="max-height: 450px"
                    class="overflow-y-auto"
                  >
                    <v-list v-for="item in history" :key="item.created_at">
                      <v-list-item>
                        <v-list-item-content
                          v-if="item.type == 'add'"
                          class="green--text"
                        >
                          <v-list-item-title class="text-h6">
                            Added {{ item.stock_count }} to stock (+
                            {{ item.stock_count }})
                          </v-list-item-title>
                          <v-list-item-subtitle class="green--text">
                            added on
                            {{ new Date(item.created_at).toDateString() }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content
                          v-if="item.type == 'remove'"
                          class="red--text"
                        >
                          <v-list-item-title class="text-h6">
                            Removed {{ item.stock_count }} to stock (-
                            {{ item.stock_count }})
                          </v-list-item-title>
                          <v-list-item-subtitle class="red--text">
                            remove on
                            {{ new Date(item.created_at).toDateString() }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    loading: false,
    loading1: false,
    loading2: false,
    product: [],
    dialog1: false,
    aStock: "",
    rStock: "",
    dialog2: false,
    history: [],
  }),

  methods: {
    back() {
      this.$router.back();
    },
    fetchHistory() {
      const data = {
        stock_id: this.$route.params.id,
      };
      fetch(
        "https://receipt.drecsoft.com/api/v1/inventory/stock-activity-history",
        {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.currentUser}`,
          },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          this.history = response.data.stocks;
          console.log(">>>>>", response.data.stocks);
        })

        .catch((err) => {
          console.log(err);
        });
    },
    fetchProduct() {
      this.loading = true;

      const data = {
        pid: this.$route.params.id,
      };
      fetch(
        "https://receipt.drecsoft.com/api/v1/inventory/fetch-product-details",

        {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.currentUser}`,
          },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          this.loading = false;
          this.product = response.data.product;
          console.log(response.data);
        })

        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },

    add(id) {
      this.loading1 = true;

      const data = {
        stock_id: id,
        stock: this.aStock,
      };
      fetch(
        "https://receipt.drecsoft.com/api/v1/inventory/update-stock",

        {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.currentUser}`,
          },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          this.$router.go();
          this.loading1 = false;

          console.log(response);
        })

        .catch((err) => {
          this.loading1 = false;
          console.log(err);
        });
    },

    remove(id) {
      this.loading2 = true;

      const data = {
        stock_id: id,
        stock: this.rStock,
      };
      fetch(
        "https://receipt.drecsoft.com/api/v1/inventory/remove-stock",

        {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.currentUser}`,
          },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          this.$router.go();

          this.loading2 = false;

          console.log(response);
        })

        .catch((err) => {
          this.loading2 = false;
          console.log(err);
        });
    },
  },

  mounted() {
    this.fetchProduct();
    this.fetchHistory();
  },

  computed: {
    ...mapGetters(["getUser", "currentUser"]),
  },
};
</script>

<style scoped>
.custom_bg {
  background: #f6f7ff;
}
</style>
